import React, { useEffect, useState, useContext } from 'react'
import QRCode from 'react-qr-code'
import AuthContext from '../../../Product/context/auth/authContext'

const QRCodeGenerator = () => {
    const authContext = useContext(AuthContext)
    const { user } = authContext

    const [value, setValue] = useState('')

    useEffect(() => {
        if (user) {
            console.log('QR Code value:', user.id)
            setValue(user.id)
        }
    }, [user])

    return value ? (
        <div className="p-4 bg-white inline-block rounded shadow">
            <QRCode
                value={String(value)}
                size={128}
                bgColor="#ffffff"
                fgColor="#000000"
                level="H"
            />
        </div>
    ) : null
}

export default QRCodeGenerator
